import exit from '~/assets/icons/exit.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import {
	setSelectedIndexNext,
	setSelectedIndexPrev,
	useLayoutDispatch,
} from '../../redux';
import { BankLogo } from '../BankLogo';
import { MenuCard } from '../MenuCard';
import { MenuItems } from '../MenuItems';
import {
	StyledButtonContent,
	StyledContainer,
	StyledTopContainer,
} from './MainMenu.styled';

const MainMenu = () => {
	const dispatch = useLayoutDispatch();

	useInputAction(InputAction.CommonMenuNavUp, () => {
		dispatch(setSelectedIndexPrev());
	});
	useInputAction(InputAction.CommonMenuNavDown, () => {
		dispatch(setSelectedIndexNext());
	});

	return (
		<StyledContainer>
			<StyledTopContainer>
				<BankLogo />
				<MenuCard />
				<MenuItems />
			</StyledTopContainer>
			<div>
				<Divider $direction="H" style={{ marginBottom: 40, opacity: 0.1 }} />
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height50}
					style={{ fontSize: 16 }}
					onClick={() => rage.bank.close()}
				>
					<StyledButtonContent>
						<img src={exit} />
						<Text>Выйти из банка</Text>
					</StyledButtonContent>
				</Button>
			</div>
		</StyledContainer>
	);
};

export { MainMenu };
